import './comments.scss'
import React from 'react';
import CommentForm from './comment-form/comment-form';
import CommentList from './comment-list/comment-list';

const Comments = ({comments, programId}) => {
	return (
		<div className="warp-comments">
			<CommentForm programId={programId}/>
			<CommentList comments={comments} />
		</div>
	);
};

export default Comments;
